import React from "react";
import { Route, Routes } from "react-router-dom";
import appLogo from "../assets/images/logo/logo+orange.png";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { useCurrentUser } from "../slices/auth/hooks";
import { AuthProtected } from "./AuthProtected";
import { authProtectedRoutes, publicRoutes, authLandingRoutes } from "./allRoutes";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const Index = () => {
  const currentUser = useCurrentUser();

  const renderPublicRoutes = () => {
    return publicRoutes.map((route, idx) => (
      <Route
        path={route.path}
        element={<NonAuthLayout>{route.component}</NonAuthLayout>}
        key={idx}
      />
    ));
  };

  const renderProtectedRoutes = () => {
    return authProtectedRoutes.map((route, idx) => (
      <Route
        path={route.path}
        element={
          <AuthProtected>
            <VerticalLayout>{route.component}</VerticalLayout>
          </AuthProtected>
        }
        key={idx}
      />
    ));
  };
  const renderLandingRoutes = () => {
    return authLandingRoutes.map((route, idx) => (
      <Route
        path={route.path}
        element={
          <AuthProtected>
            {route.component}
          </AuthProtected>
        }
        key={idx}
      />
    ));
  };

  return (
    <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY}>
      <Routes>
        {!currentUser ? (
          <>
            {renderPublicRoutes()}
            <Route
              path="*"
              element={
                <NonAuthLayout>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100vh",
                      width: "100vw",
                      flexDirection: "column",
                    }}
                  >
                    <img
                      src={appLogo}
                      alt="app-logo"
                      border="0"
                      style={{ width: "50vw", maxWidth: "320px" }}
                    />
                    <span>Loading..</span>
                  </div>
                </NonAuthLayout>
              }
            />
          </>
        ) : (
          <>
          {renderProtectedRoutes()}
          {renderLandingRoutes()}
          </>
        )}
      </Routes>
    </GoogleReCaptchaProvider>
  );
};

export default Index;
